import { render } from "./ethetical-behno-standard.vue?vue&type=template&id=0d7900e9&scoped=true"
import script from "./ethetical-behno-standard.vue?vue&type=script&lang=js"
export * from "./ethetical-behno-standard.vue?vue&type=script&lang=js"

import "./ethetical-behno-standard.vue?vue&type=style&index=0&id=0d7900e9&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7900e9"]])

export default __exports__